import React from "react";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";

interface InputProps {
  id?: string;
  name?: string;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
  fieldClassName?: string;
  error?: string;
  label?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  type?: "text" | "email" | "password" | "number" | "tel" | "url";
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  autoComplete?: string;
}

export function Input({
  id,
  name,
  value,
  placeholder,
  disabled = false,
  required = false,
  className,
  fieldClassName,
  error,
  label,
  onChange,
  onBlur,
  type = "text",
  onKeyDown,
  autoComplete = "off",
}: InputProps) {
  const inputId = id || name;

  return (
    <div className={classNames("field", fieldClassName)}>
      {label && (
        <label htmlFor={inputId} className="block mb-2">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <InputText
        id={inputId}
        name={name}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        type={type}
        className={classNames("w-full", { "p-invalid": error }, className)}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        autoComplete={autoComplete}
      />
      {error && <small className="p-error block mt-1">{error}</small>}
    </div>
  );
}
